"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformer = exports.generator = exports.transpile = void 0;
/**
 * This package provides both a cli and an exported function to
 * allow for transpiling within a file or across a directory.
 */
const transpile_1 = require("./transpile");
Object.defineProperty(exports, "transpile", { enumerable: true, get: function () { return transpile_1.transpile; } });
const generator_1 = require("./generator");
Object.defineProperty(exports, "generator", { enumerable: true, get: function () { return generator_1.generator; } });
const transformer_1 = require("./transformer");
Object.defineProperty(exports, "transformer", { enumerable: true, get: function () { return transformer_1.transformer; } });
